'use strict';

import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';

// Services
const __endpoints = require('endpoints.service');
const __enums = require('enums.service');

export default class BadgeCategoriesList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: true,
			},
			{
				name: 'description',
				type: 'string',
				canAdd: true,
				canEdit: true,
				required: false,
			},
			{
				name: 'type',
				type: 'select',
				canAdd: true,
				canEdit: true,
				required: false,
				options: {
					enums: __enums.badgeCategories,
				},
			},
		];
		this.settings = {
			name: 'BadgeCategoriesList',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			pageTitle: true,
			searchList: {
				canAdd: true,
				canDelete: true,
			},
			canManipulate: () => validAccess(undefined, ['Global BI Configuration']),
			translationPath: 'HR.BADGE_CATEGORIES',
			endpoint: __endpoints.collection.hr.badge_categories,
		};
		this.init();
		return this;
	}
}
